import { Icon, Link } from '@chakra-ui/react'
import { formatISO } from 'date-fns'
import { isEmpty } from 'lodash'
import React, { useState } from 'react'
import { FaDownload } from 'react-icons/fa'
import { assembleTransferDetailsCsv } from '.'
import { AlpsAcatDetailV2WebDto, AuditTrail } from '../../../../api/types'
import { Asset } from '../../../../types/Asset'

export interface ExportTransferDetailsLinkProps {
  assets: Asset[]
  auditTrail?: AuditTrail[]
  transferDetails?: AlpsAcatDetailV2WebDto
  loadingAssets: boolean
  loadingAuditTrail: boolean
  loadingTransferDetails: boolean
}

const ExportTransferDetailsLink = ({
  assets,
  auditTrail,
  transferDetails,
  loadingAssets,
  loadingAuditTrail,
  loadingTransferDetails,
}: ExportTransferDetailsLinkProps) => {
  const getCsvName = () =>
    `${transferDetails?.acatsControlNumber}_${formatISO(new Date())}.csv`
  const [csvName, setCsvName] = useState(getCsvName())

  return (
    <Link
      download={csvName}
      color={
        loadingTransferDetails || loadingAuditTrail || loadingAssets
          ? 'apex.lightGray'
          : 'apex.link'
      }
      href={
        isEmpty(transferDetails) || isEmpty(auditTrail)
          ? undefined
          : assembleTransferDetailsCsv(transferDetails!, auditTrail!, assets)
      }
      onFocus={() => setCsvName(getCsvName())}
      onMouseOver={() => setCsvName(getCsvName())}
    >
      <Icon as={FaDownload} mr={1} />
      Export
    </Link>
  )
}

export default ExportTransferDetailsLink
